//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapGetters } from 'vuex'

export default {
  name: 'AppHeaderNav',

  data() {
    return {
      showBag: false
    }
  },

  computed: {
    ...mapGetters({
      bagCount: 'cart/bagCount',
      isGuest: 'user/isGuest',
      isSubscriber: 'user/isSubscriber',
      isUser: 'user/isUser'
    }),

    hideCheckoutNav() {
      return ['recommendations', 'checkout'].includes(this.$route.name)
    },

    hideBag() {
      return ['landing-quiz-questionNumber', 'landing-register'].includes(
        this.$route.name
      )
    }
  },

  methods: {
    toggleBag() {
      this.showBag = !this.showBag
    }
  }
}
